const scene = "service/";

export const UPDATE_SERVICE = `${scene}UPDATE_SERVICE`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
